import {
  STOCK_DICTIONARY_FETCH_CAR_LOTS_BEGIN,
  STOCK_DICTIONARY_FETCH_CAR_LOTS_SUCCESS,
  STOCK_DICTIONARY_FETCH_CAR_LOTS_FAILURE
} from '../constants'

export function reducer(state, action) {
  switch (action.type) {
    case STOCK_DICTIONARY_FETCH_CAR_LOTS_BEGIN:
      return {
        ...state,
        getDictionaryCarLotsPending: true,
        dictionaryCarlots: null
      }
    case STOCK_DICTIONARY_FETCH_CAR_LOTS_SUCCESS:
      return {
        ...state,
        getDictionaryCarLotsPending: false,
        dictionaryCarlots: action.data
      }
    case STOCK_DICTIONARY_FETCH_CAR_LOTS_FAILURE:
      return {
        ...state,
        getDictionaryCarLotsPending: false,
        getDictionaryCarLotsError: action.data.error
      }
    default:
      return state
  }
}
